const errors = {
  noName: `Make sure that a message has a "name" property.`,
  noPublisher: (name: string): string =>
    `No publisher for a message called "${name}". Make sure the "name" property of a message is correct.`,
};

export function selectNotifier(message: Message, observers: PublishersPool): void {
  const {name} = message;
  if (!name) throw new Error(errors.noName);
  if (!observers[name]) throw new Error(errors.noPublisher(name));
  observers[name].notify(message);
}
